const TASK_COLLISIONS = {
  'crushftp-group-reconciliation': {
    tasks: ['crushftp-reconciliation', 'disconnect-group-crushftp'],
    noRelatedEntity: false,
  },
  'crushftp-reconciliation': {
    tasks: ['crushftp-group-reconciliation', 'disconnect-group-crushftp'],
    noRelatedEntity: true,
  },
  'disconnect-group-crushftp': {
    tasks: ['crushftp-reconciliation', 'crushftp-group-reconciliation'],
    noRelatedEntity: false,
  },
};

const wouldCauseTaskCollision = (
  collidingTaskId: string,
  collidingRelatedEntityId: string,
  noRelatedEntity: boolean,
  runningTasks: { taskId: string; relatedEntityId: string }[]
) => {
  const prohibitsRunningTheExecution = ({ taskId, relatedEntityId }: { taskId: string; relatedEntityId: string }) => {
    const ignoreRelatedEntity = noRelatedEntity || !relatedEntityId;
    const collidesWithRelatedEntityId = ignoreRelatedEntity || relatedEntityId === collidingRelatedEntityId;
    return taskId === collidingTaskId && collidesWithRelatedEntityId;
  };
  return runningTasks.some(prohibitsRunningTheExecution);
};

export const isExecutionColliding = (
  { taskId, relatedEntityId }: { taskId: keyof typeof TASK_COLLISIONS; relatedEntityId: string },
  runningTasks = []
) => {
  const { tasks: collidingTasks = [], noRelatedEntity } = TASK_COLLISIONS[taskId] || {};
  const collidingTaskIds = [taskId, ...collidingTasks];
  return collidingTaskIds.some((collidingTaskId) =>
    wouldCauseTaskCollision(collidingTaskId, relatedEntityId, noRelatedEntity, runningTasks)
  );
};
